// @flow
import React from "react";
import { type FormProps } from "redux-form";
import { CategoryTypes } from "Commons/Modules/category";
import { COMPANY } from "Commons/Utilities/Constants/PropertyTypes";
import {
  CompanyName,
  TaxId,
  StreetAndStreetNumber,
  SalutationFields,
  FirstName,
  LastName,
  PostalCodeAndLocation,
} from "modules/ChangeService/components/FormComponents";

import type { ChangeServiceT } from "modules/ChangeService/misc/Types";

type FieldsT = {
  salutation: string,
  salutationTitle: string,
  firstName: string,
  lastName: string,
  companyName: string,
  taxId?: string,
  street: string,
  streetNumber: string,
  postalCode: string,
  locationId: string,
  locationMainName: string,
  locationName: string,
  locationPartName: string,
};

type AddressFormT = {|
  t: typeof TFunction,
  initialValues: ChangeServiceT | {},
  currentValues: ChangeServiceT,
  fields: FieldsT,
  form: string,
  change: $PropertyType<FormProps, "change">,
  dataCy: string,
  mobileChangeService?: boolean,
  divider?: boolean,
|};

export const AddressForm = (props: AddressFormT) => {
  const { t, initialValues, currentValues, fields, form, change, mobileChangeService = false, dataCy, divider } = props;

  // This value ultimately used for the API endpoint.
  const category = initialValues.category === CategoryTypes.GAS ? "gas" : "electricity";

  return (
    <div data-cy={dataCy}>
      <SalutationFields divider={divider} t={t} fields={fields} mobileChangeService={mobileChangeService} />
      <FirstName t={t} divider={divider} fields={fields} />
      <LastName t={t} divider={divider} fields={fields} />
      {currentValues.propertyType === COMPANY && (
        <>
          <CompanyName divider={divider} fields={fields} t={t} />
          {!!fields.taxId && <TaxId divider={divider} fields={fields} t={t} />}
        </>
      )}
      <PostalCodeAndLocation
        fields={fields}
        t={t}
        divider={divider}
        category={category}
        initialValues={initialValues}
        form={form}
        change={change}
      />
      <StreetAndStreetNumber
        form={form}
        divider={divider}
        t={t}
        fields={fields}
        initialValues={initialValues}
        change={change}
        mobileChangeService={mobileChangeService}
      />
    </div>
  );
};
